type CronUtilsParams = {
  currentDate: Date;
  hours: string[];
  weekDays: string[];
  months: string[];
};

export const checkHours = ({
  currentDate,
  hours,
}: Pick<CronUtilsParams, 'currentDate' | 'hours'>) => {
  return hours.some(hour => {
    if (hour.length > 2) {
      const [minHour, maxHour] = hour.split('-');
      const currentHour = currentDate.getHours();
      if (
        parseInt(minHour, 10) <= currentHour &&
        currentHour <= parseInt(maxHour, 10)
      ) {
        return true;
      }
    } else {
      if (hour === '*' || parseInt(hour, 10) === currentDate.getHours()) {
        return true;
      }
    }
    return false;
  });
};

export const checkDays = ({
  currentDate,
  weekDays,
  ...rest
}: Omit<CronUtilsParams, 'months'>) => {
  return weekDays.some(weekDay => {
    if (weekDay.length > 1) {
      const [minDay, maxDay] = weekDay.split('-');
      const currentDay = currentDate.getDay();
      if (
        parseInt(minDay, 10) <= currentDay &&
        currentDay <= parseInt(maxDay, 10)
      ) {
        return checkHours({ currentDate, ...rest });
      }
    } else {
      if (weekDay === '*' || parseInt(weekDay, 10) === currentDate.getDay()) {
        return checkHours({ currentDate, ...rest });
      }
    }
    return false;
  });
};

export const checkMonths = ({
  currentDate,
  months,
  ...rest
}: CronUtilsParams) => {
  return months.some(month => {
    if (month.length > 2) {
      const [minMonth, maxMonth] = month.split('-');
      const currentMonth = currentDate.getMonth() + 1;
      if (
        parseInt(minMonth, 10) <= currentMonth &&
        currentMonth <= parseInt(maxMonth, 10)
      ) {
        return checkDays({ currentDate, ...rest });
      }
    } else {
      if (month === '*' || parseInt(month, 10) === currentDate.getMonth() + 1) {
        return checkDays({ currentDate, ...rest });
      }
    }
    return false;
  });
};
